import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddSquareIcon } from '../../../../assets/images/AddSquareIcon.svg';
import { ReactComponent as GlobeIcon } from '../../../../assets/images/GlobeIcon.svg';
import { ReactComponent as GreenPlusICon } from '../../../../assets/images/GreenPlusIcon.svg';
import Tooltip from '../../../../components/shared/Tooltip/Tooltip';

import AddExperienceModal from './AddExperienceModal/AddExperienceModal';
import ExperienceDetails from './ExperienceDetails';

import styles from './Experience.module.scss';

const Experience = ({ experienceData = [], allowEdit, handleProfileUpdate }) => {
  const { t } = useTranslation('common');
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    if (!showModal) {
      setFormValues({});
    }
  }, [showModal]);

  const handleOpenModal = useCallback((data = {}) => {
    setFormValues(data);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleSave = useCallback((data) => {
    handleProfileUpdate({ user_experiences_attributes: data }, closeModal());
  }, []);

  return !allowEdit && experienceData.length === 0 ? null : (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <div className={styles.containerHeading}>
          <div className={styles.heading}>{t('account.experience')}</div>
          {allowEdit && (
            <Tooltip text={t('profile.sectionIsPublic')}>
              <span className={styles.headingGlobe}>
                <GlobeIcon />
              </span>
            </Tooltip>
          )}
        </div>
        {allowEdit && experienceData.length !== 0 && (
          <div>
            <button type="button" onClick={() => handleOpenModal({})} className={styles.addExperience}>
              <AddSquareIcon />
            </button>
          </div>
        )}
      </div>
      <div className={styles.containerBody}>
        {experienceData.length ? (
          <ExperienceDetails experienceData={experienceData} allowEdit={allowEdit} handleOpenModal={handleOpenModal} />
        ) : (
          <div className={styles.noExperience}>
            <button type="button" className={styles.noExperienceButton} onClick={() => handleOpenModal({})}>
              <GreenPlusICon /> <span className={styles.noExperienceText}>{t('profile.addExperience')}</span>
            </button>
          </div>
        )}
      </div>
      {showModal && (
        <AddExperienceModal
          showModal={showModal}
          setShowModal={setShowModal}
          initialValues={formValues}
          handleSave={handleSave}
          formData={experienceData}
        />
      )}
    </div>
  );
};

export default Experience;
